<template>
  <div
    v-if="showAd && notEmptyAd"
    id="wegow-ads-dynamic"
    :class="{
      'fix-box': fixBox,
      'fix-box-110': verticalPosition === 110,
      'fix-box-160': verticalPosition === 160,
      'fix-box-240': verticalPosition === 240,
      'small-box': smallBox,
      'close-box': closeBox,
      'big-box': bigBox,
      'video-in-banner': videoInBanner,
      'expand-video': expandVideo,
      'hide-ad': hideAd
    }"
    class="wegow-ads-dynamic"
  >
    <div
      class="wegow-ads-dynamic-container"
      @mouseover="smallBox = false"
      @mouseout="smallBox = true"
    >
      <wegow-ads
        class="desktop-event-dynamic"
        :values="valuesCopy"
        adstype="wegow-web-dynamic-ad"
        @empty-dynamic-ad="notEmptyAd = false"
      />
      <p class="desktop-event-dynamic-small-text">WegowAds</p>
      <span class="close-arrow" @click="closeAd" />
    </div>
    <div class="wegow-ads-close-arrow" @click="closeBox = !closeBox" />
    <div v-if="modalVideo" id="modalVideoAds" class="modalVideoAds">
      <!-- <script src="https://cdnjs.cloudflare.com/ajax/libs/video.js/6.6.2/video.min.js"></script> -->
      <span class="modal-close-arrow" @click="closeVideoModal" />
      <div class="video-modal">
        <video-player
          v-if="videoPlayerExists"
          :options="playerOptions"
          class="video-player-box"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import Vue, { onMounted, ref } from "vue";
import WegowAds from "@/components/general/ads/smartclip/WegowAds.vue";
const props = defineProps({
  values: {
    type: Object,
    default: () => {}
  }
});

const valuesCopy = ref(undefined);

const fixBox = ref(false);
const smallBox = ref(false);
const closeBox = ref(false);
const bigBox = ref(true);
const videoInBanner = ref(false);
const expandVideo = ref(false);
const modalVideo = ref(false);
const hideAd = ref(false);
const verticalPosition = ref(0);
const playerOptions = ref({});
const showAd = ref(true);
const notEmptyAd = ref(true);
const videoPlayerExists = ref(false);

const videoPlayer = ref(null);

onMounted(async () => {
  valuesCopy.value = props.values;
  if (!valuesCopy.value.id)
    valuesCopy.value.id = `wegow-ads-container-${parseInt(
      Math.random() * 1000
    )}`;
  // showAd.value = window.canRunAds;
  window.addEventListener("scroll", handleScroll);
  window.addEventListener(
    "message",
    event => {
      if (event.data && event.data.video_in_banner) {
        openVideoInBanner(event);
      } else if (event.data && event.data.event === "expandVideo") {
        openExpandVideo(event);
      } else if (event.data && event.data.event === "collapseVideo") {
        collapseVideo(event);
      } else if (event.data && event.data.video_url_mp4) {
        openVideoModal(event.data);
      }
    },
    false
  );
  handleScroll();

  let typeElement = document.getElementById("modalVideoAds");
  if (typeElement) {
    let newScript = document.createElement("script");
    newScript.src =
      "https://cdnjs.cloudflare.com/ajax/libs/video.js/6.6.2/video.min.js";

    newScript.defer = true;
    typeElement.appendChild(newScript);
  }
  const script = document.createElement("script");
  script.src =
    "https://cdn.jsdelivr.net/npm/vue-video-player@5.0.0/dist/vue-video-player.js";
  script.addEventListener("load", () => {
    videoPlayer.value = window.videoPlayer;
    videoPlayerExists.value = true;
  });

  script.defer = true;
  document.body.appendChild(script);

  // if (typeof this.$loadScript === "function") {
  //   await this.$loadScript(
  //     "https://cdn.jsdelivr.net/npm/vue-video-player@5.0.0/dist/vue-video-player.js"
  //   ).then(() => {
  //     this.$options.components.videoPlayer = Vue.component(
  //       "VideoPlayer",
  //       window.videoPlayer
  //     );
  //     videoPlayerExists.value = true;
  //   });
  // }
});

const handleScroll = () => {
  var thereIsHeader = document.getElementsByTagName("header")[0]
    ? document.getElementsByTagName("header")[0].className.includes("fadeIn")
    : false;
  var thereIsBuyBanner = document.getElementById("buy-banner")
    ? document.getElementById("buy-banner").className.includes("fadeIn")
    : false;

  if (thereIsHeader && !thereIsBuyBanner) {
    verticalPosition.value = 110;
  } else if (!thereIsHeader && thereIsBuyBanner) {
    verticalPosition.value = 160;
  } else if (thereIsHeader && thereIsBuyBanner) {
    verticalPosition.value = 240;
  } else {
    verticalPosition.value = 110;
  }
  if (window.scrollY > 290 || (window.scrollY > 62 && videoInBanner.value)) {
    fixBox.value = true;
    if (!videoInBanner.value) {
      bigBox.value = false;
      smallBox.value = true;
    } else {
      bigBox.value = true;
      smallBox.value = false;
    }
  } else {
    fixBox.value = false;
    bigBox.value = true;
    smallBox.value = false;
  }
};
const openVideoInBanner = event => {
  if (event.data.video_in_banner_open) {
    videoInBanner.value = true;
  } else {
    videoInBanner.value = false;
  }
  handleScroll();
};
const openExpandVideo = event => {
  expandVideo.value = true;
};
const collapseVideo = event => {
  expandVideo.value = false;
};
const openVideoModal = data => {
  modalVideo.value = true;
  playerOptions.value = {
    autoplay: true,
    language: "en",
    fluid: true,
    sources: [
      {
        type: "video/mp4",
        src: data.video_url_mp4
      }
    ]
  };
};
const closeVideoModal = data => {
  modalVideo.value = false;
  playerOptions.value = {};
};
const closeAd = () => {
  hideAd.value = true;
  // this.$root.$emit("hidedynamicAd");
  // Añadir en el banner
};

//   head() {
//     return {
//       link: [
//         { rel: "stylesheet", href: "https://vjs.zencdn.net/7.6.6/video-js.css" }
//       ]
//     };
//   }
</script>

<style lang="scss">
@import "./dynamic-ads.scss";
</style>

<style lang="css">
@import "./dynamic-ads-videos.css";
</style>
